/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown>, scope: NonNullable<unknown> }} Task_Catalog_Issue_DefinitionInputs */

const en_task_catalog_issue_definition = /** @type {(inputs: Task_Catalog_Issue_DefinitionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} in ${i?.scope} has settings this task type would no longer allow. Adjust its flow first.`)
};

const pt_br2_task_catalog_issue_definition = /** @type {(inputs: Task_Catalog_Issue_DefinitionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} em ${i?.scope} tem configurações que este tipo de tarefa deixaria de permitir. Ajuste o fluxo dela antes.`)
};

/**
* | output |
* | --- |
* | "{task} in {scope} has settings this task type would no longer allow. Adjust its flow first." |
*
* @param {Task_Catalog_Issue_DefinitionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_issue_definition = /** @type {((inputs: Task_Catalog_Issue_DefinitionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Issue_DefinitionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_issue_definition(inputs)
	return pt_br2_task_catalog_issue_definition(inputs)
});